"use strict";
// private _baseURL: string = 'https://api.attensi.com/api/v1';
Object.defineProperty(exports, "__esModule", { value: true });
var Environment;
(function (Environment) {
    Environment["STAGING"] = "STAGING";
    Environment["PRODUCTION"] = "PRODUCTION";
    Environment["BACKEND"] = "BACKEND";
})(Environment = exports.Environment || (exports.Environment = {}));
/**
 * @hidden
 */
var EnvironmentVariables = /** @class */ (function () {
    function EnvironmentVariables() {
    }
    /**
     * Returns the base url for the environment
     * @param { Environment } environment
     * @returns { string } baseUrl
     */
    EnvironmentVariables.getBaseUrl = function (env) {
        switch (env) {
            case Environment.STAGING: {
                return 'https://api-staging.attensi.com/api/v1';
            }
            case Environment.PRODUCTION: {
                return 'https://api.attensi.com/api/v1';
            }
            case Environment.BACKEND: {
                return 'https://backend.attensi.com/api/v1';
            }
            default: {
                return 'https://backend.attensi.com/api/v1';
            }
        }
    };
    return EnvironmentVariables;
}());
exports.EnvironmentVariables = EnvironmentVariables;
//# sourceMappingURL=environments.js.map